module.exports = {"aggressive":"Aggressivo","unfriendly":"Ostile","neutral":"Neutrale","friendly":"Amichevole","awakened":"Risvegliato"};